<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<p class="p-c-br"><em class="i">‘Where is the Prince who can afford so to cover his country</em> <br/><em class="i">with troops for its defense, as that 10,000 men descending</em> <br/><em class="i">from the clouds, might not, in many places, do an infinite</em> <br/><em class="i">deal of mischief before a force could be brought together to</em> <br/><em class="i">repel them?</em></p>
<p class="p-c"><strong class="b">Benjamin Franklin 1784</strong></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783468874_fm01.vue?7a1d649e